(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-game-video"] && !Shopify.designMode) return;
  try {
    
  // Load Swiper JS dynamically if not already loaded
  function loadSwiper() {
    return new Promise((resolve, reject) => {
      if (typeof Swiper !== 'undefined') {
        resolve();
        return;
      }

      // Add CSS only once
      const cssHref = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      if (!document.querySelector(`link[href="${cssHref}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = cssHref;
        document.head.appendChild(link);
      }

      const scriptSrc = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      if (document.querySelector(`script[src="${scriptSrc}"]`)) {
        // Script already requested; wait until it's available
        const check = setInterval(() => {
          if (typeof Swiper !== 'undefined') {
            clearInterval(check);
            resolve();
          }
        }, 50);
        return;
      }

      const script = document.createElement('script');
      script.src = scriptSrc;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Initialize Swiper for this section
  function initGameVideoSwiper(sectionElement) {
    const sectionId = sectionElement.dataset.sectionId;
    const swiperEl = sectionElement.querySelector(`#game-video-swiper-${sectionId}`);
    if (!swiperEl) return;

    const wrapper = swiperEl.querySelector('.swiper-wrapper');

    // helper: check if items overflow horizontally
    const isOverflowing = () => wrapper.scrollWidth > swiperEl.clientWidth + 2;

    // if NO overflow: make it static (centered) and no swiper
    const makeStatic = () => {
      sectionElement.classList.add('is-static');
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);
    };

    // if overflow: enable swiper
    const makeSwiper = () => {
      sectionElement.classList.remove('is-static');
      if (swiperEl.swiper) swiperEl.swiper.destroy(true, true);

      new Swiper(swiperEl, {
        slidesPerView: 'auto', // works with fixed slide width
        centerInsufficientSlides: true, // if few slides, still center
        spaceBetween: 10,
        grabCursor: true,
        loop: false, // IMPORTANT: keep false

        navigation: {
          nextEl: `.swiper-button-next-${sectionId}`,
          prevEl: `.swiper-button-prev-${sectionId}`,
        },
        pagination: {
          el: `.swiper-pagination-${sectionId}`,
          clickable: true,
        },
      });
    };

    // decide mode
    if (isOverflowing()) makeSwiper();
    else makeStatic();

    // re-check on resize
    let t;
    window.addEventListener('resize', () => {
      clearTimeout(t);
      t = setTimeout(() => {
        if (isOverflowing()) makeSwiper();
        else makeStatic();
      }, 150);
    });
  }

  // Video modal functionality
  function initVideoModal(sectionElement) {
    const sectionId = sectionElement.dataset.sectionId;
    const modal = document.getElementById(`videoModal-${sectionId}`);
    const iframe = document.getElementById(`videoIframe-${sectionId}`);
    const video = document.getElementById(`videoPlayer-${sectionId}`);
    const closeBtn = document.getElementById(`videoClose-${sectionId}`);

    if (!modal) return;

    // Find video items within this specific section
    sectionElement.querySelectorAll('.video-item').forEach((item) => {
      if (item.dataset.modalBound === 'true') return; // ✅ prevents duplicates
      item.dataset.modalBound = 'true';

      item.addEventListener('click', () => {
        const url = item.dataset.videoUrl;
        const file = item.dataset.videoFile;

        iframe.style.display = 'none';
        video.style.display = 'none';

        if (file) {
          video.innerHTML = '';
          const source = document.createElement('source');
          source.src = file;
          source.type = 'video/mp4';

          video.appendChild(source);
          video.muted = true;
          video.style.display = 'block';
          video.load();
          video.play().catch(() => {});
        } else if (url) {
          let embedUrl = url;

          if (url.includes('youtube.com/watch')) {
            const videoId = url.split('v=')[1]?.split('&')[0];
            embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          } else if (url.includes('youtu.be')) {
            const videoId = url.split('/').pop();
            embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
          } else if (url.includes('vimeo.com')) {
            const videoId = url.split('/').pop();
            embedUrl = `https://player.vimeo.com/video/${videoId}?autoplay=1`;
          }

          iframe.src = embedUrl;
          iframe.style.display = 'block';
        }

        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    function closeModal() {
      modal.classList.remove('active');
      document.body.style.overflow = '';

      iframe.src = '';
      iframe.style.display = 'none';

      if (video) {
        video.pause();
        video.currentTime = 0;
        video.innerHTML = '';
        video.style.display = 'none';
      }
    }

    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
      if (e.target === modal) closeModal();
    });

    // Close modal with Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        closeModal();
      }
    });
  }

  // Initialize all game video sections
  function initAllGameVideoSections() {
    const sections = document.querySelectorAll('.game-video[data-section-id]');

    loadSwiper()
      .then(() => {
        sections.forEach((sectionElement) => {
          initGameVideoSwiper(sectionElement);
          initVideoModal(sectionElement);
        });
      })
      .catch((error) => {
        console.error('Failed to load Swiper:', error);
      });
  }

  // Initialize when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllGameVideoSections);
  } else {
    initAllGameVideoSections();
  }

  // Handle section reinitialization for Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const sectionElement = document.getElementById(`game-video-section-${event.detail.sectionId}`);
      if (sectionElement && sectionElement.classList.contains('game-video')) {
        loadSwiper().then(() => {
          initGameVideoSwiper(sectionElement);
          initVideoModal(sectionElement);
        });
      }
    });

    document.addEventListener('shopify:section:unload', (event) => {
      // Clean up Swiper instances when section is unloaded
      const sectionElement = document.getElementById(`game-video-section-${event.detail.sectionId}`);
      if (sectionElement) {
        const swiperEl = sectionElement.querySelector(`#game-video-swiper-${event.detail.sectionId}`);
        if (swiperEl && swiperEl.swiper) {
          swiperEl.swiper.destroy();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
